import React from 'react';
import { PrimaryButton } from '../ui/Buttons';
import { useSticker } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
function fmt(n: number) {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
}
export function SizePanel() {
  const {
    width,
    setWidth,
    height,
    setHeight,
    squareInches,
    totalPrice
  } = useSticker();
  const {
    addToast
  } = useToast();
  return <div className="h-full flex flex-col" data-id="element-294">
      <div className="p-4 border-b border-gray-100" data-id="element-295">
        <h2 className="font-semibold text-[#111111]" data-id="element-296">Sticker Size</h2>
      </div>
      <div className="p-4 space-y-5 overflow-y-auto flex-1" data-id="element-297">
        <p className="text-xs text-[#5F5F5F]" data-id="element-298">
          Enter your finished sticker size in inches. Size includes the cut line
          or shape of your sticker.
        </p>
        <div data-id="element-299">
          <label className="text-xs font-medium text-[#5F5F5F] block mb-1" data-id="element-300">
            Width
          </label>
          <div className="relative" data-id="element-301">
            <input type="number" min={0.1} max={50} step={0.1} value={width || ''} placeholder="e.g. 3.5" onChange={e => {
            const val = parseFloat(e.target.value) || 0;
            setWidth(val > 50 ? 50 : val);
          }} className="w-full rounded-lg border border-[#D9D9D9] px-4 py-2.5 pr-10 text-sm focus:ring-2 focus:ring-[#008696] focus:border-[#008696] outline-none" data-id="element-302" />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#5F5F5F] font-medium" data-id="element-303">
              in
            </span>
          </div>
        </div>
        <div data-id="element-304">
          <label className="text-xs font-medium text-[#5F5F5F] block mb-1" data-id="element-305">
            Height
          </label>
          <div className="relative" data-id="element-306">
            <input type="number" min={0.1} step={0.1} value={height || ''} placeholder="e.g. 3.5" onChange={e => setHeight(parseFloat(e.target.value) || 0)} className="w-full rounded-lg border border-[#D9D9D9] px-4 py-2.5 pr-10 text-sm focus:ring-2 focus:ring-[#008696] focus:border-[#008696] outline-none" data-id="element-307" />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#5F5F5F] font-medium" data-id="element-308">
              in
            </span>
          </div>
        </div>
        {width > 0 && height > 0 && <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1" data-id="element-309">
            <div className="flex justify-between" data-id="element-310">
              <span className="text-[#5F5F5F]" data-id="element-311">Dimensions</span>
              <span className="font-medium text-[#111111]" data-id="element-312">
                {width} × {height} in
              </span>
            </div>
            <div className="flex justify-between" data-id="element-313">
              <span className="text-[#5F5F5F]" data-id="element-314">Square inches</span>
              <span className="font-medium text-[#111111]" data-id="element-315">
                {squareInches.toFixed(2)} sq in
              </span>
            </div>
            <div className="flex justify-between" data-id="element-316">
              <span className="text-[#5F5F5F]" data-id="element-317">Total</span>
              <span className="font-medium text-[#111111]" data-id="element-318">
                {totalPrice > 0 ? fmt(totalPrice) : '—'}
              </span>
            </div>
          </div>}
      </div>
      <div className="p-4 border-t border-gray-100" data-id="element-319">
        <PrimaryButton className="w-full" onClick={() => addToast('Size updated')} disabled={width <= 0 || height <= 0} data-id="element-320">
          Continue
        </PrimaryButton>
      </div>
    </div>;
}